import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _cffe3db6 = () => interopDefault(import('~/pages/_.vue' /* webpackChunkName: "" */))
const _fe9de024 = () => interopDefault(import('../../../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-eagle-strategies",
    component: _cffe3db6,
    name: "about-eagle-strategies"
  }, {
    path: "/about-the-nautilus-group",
    component: _cffe3db6,
    name: "about-the-nautilus-group"
  }, {
    path: "/belize-fall-2018",
    component: _cffe3db6,
    name: "belize-fall-2018"
  }, {
    path: "/cambodiavietnam-fall-2019",
    component: _cffe3db6,
    name: "cambodiavietnam-fall-2019"
  }, {
    path: "/client-login",
    component: _cffe3db6,
    name: "client-login"
  }, {
    path: "/contact-information",
    component: _cffe3db6,
    name: "contact-information"
  }, {
    path: "/copyright",
    component: _cffe3db6,
    name: "copyright"
  }, {
    path: "/costa-rica-winter-2019",
    component: _cffe3db6,
    name: "costa-rica-winter-2019"
  }, {
    path: "/curacao-winter-2023",
    component: _cffe3db6,
    name: "curacao-winter-2023"
  }, {
    path: "/educational-resources",
    component: _cffe3db6,
    name: "educational-resources"
  }, {
    path: "/hawaii-fall-2021",
    component: _cffe3db6,
    name: "hawaii-fall-2021"
  }, {
    path: "/holistic-financial-planning",
    component: _cffe3db6,
    name: "holistic-financial-planning"
  }, {
    path: "/israel-spring-2018",
    component: _cffe3db6,
    name: "israel-spring-2018"
  }, {
    path: "/italy-summer-2023",
    component: _cffe3db6,
    name: "italy-summer-2023"
  }, {
    path: "/japan-fall-2023",
    component: _cffe3db6,
    name: "japan-fall-2023"
  }, {
    path: "/london-fall-2018",
    component: _cffe3db6,
    name: "london-fall-2018"
  }, {
    path: "/our-founder-and-firm",
    component: _cffe3db6,
    name: "our-founder-and-firm"
  }, {
    path: "/prague-krakow-and-warsaw-summer-2023",
    component: _cffe3db6,
    name: "prague-krakow-and-warsaw-summer-2023"
  }, {
    path: "/roatan-summer-2021",
    component: _cffe3db6,
    name: "roatan-summer-2021"
  }, {
    path: "/russia-2019",
    component: _cffe3db6,
    name: "russia-2019"
  }, {
    path: "/special-needs-planning",
    component: _cffe3db6,
    name: "special-needs-planning"
  }, {
    path: "/travel-blog",
    component: _cffe3db6,
    name: "travel-blog"
  }, {
    path: "/turkey-summer-2022",
    component: _cffe3db6,
    name: "turkey-summer-2022"
  }, {
    path: "/video-library",
    component: _cffe3db6,
    name: "video-library"
  }, {
    path: "/",
    component: _cffe3db6,
    name: "home"
  }, {
    path: "/*",
    component: _fe9de024,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
